module.exports = __webpack_public_path__ + "media/background.0df330b8.mp4";